// translate router.meta.title, be used in breadcrumb sidebar tagsview
export function generateTitle(title) {
    const hasKey = this.$te('route.' + title)
    const translatedTitle = this.$t('route.' + title) // $t :this method from vue-i18n, inject in @/lang/index.js

    if (hasKey) {
        return translatedTitle
    }
    return title
}

import i18n from '@/lang'

export function translateMenuTitle(name) {
    const map = {
        '首页': 'navbar.dashboard',
        '项目管理': 'navbar.projectManagement',
        '回收中心': 'navbar.recycleBin',
        '系统管理': 'navbar.systemManagement',
        '用户管理': 'navbar.userManagement',
        '角色管理': 'navbar.roleManagement',
        '菜单管理': 'navbar.menuManagement',
        '项目列表': 'navbar.projectList',
        '自动化报告': 'navbar.automatedReport',
        '系统配置': 'navbar.systemSettings',
        '收藏中心': 'navbar.favoritesCenter',
        '协作问卷': 'navbar.collaborativeSurvey',
        '推送中心': 'navbar.pushCenter'
    }
    const key = map[name]
    return key ? i18n.t(key) : name
}
